import workTypeLocationIcon from '@atom/components/common/svgIcons/workTypeLocationIcon.svg';

import classes from './workTemplateInfo.module.css';

const WorkTemplateMap = () => {
  return (
    <div className={classes.locationSection}>
      <div className={classes.locationContent}>
        <img className={classes.locationImage} src={workTypeLocationIcon} />
        <div className={classes.locationTitle}>
          Location is determined during work creation.
        </div>
        <div className={classes.locationText}>
          When location is enabled in work, this section will display the
          location of that work on a map. For work with inventory, the map will
          display the location of the work and the location of the inventory in
          the same location, unless modified.
        </div>
      </div>
    </div>
  );
};

export default WorkTemplateMap;
